module.exports = __webpack_public_path__ + "static/img/5389_phase_function_Paper_Points.d77ce05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5389_phase_function_Paper_Points.png
// module id = 5i+K
// module chunks = 0